import { Loader } from '@airship-platform/jam-web/components';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useAppointmentHistory } from '../../../data-access/appointmentHistory';
import ProposalTemplatesHistoryDetail from './ProposalTemplatesHistoryDetail';

const ProposalTemplatesHistoryDetailView: React.FC = () => {
  const { currentAppointment, isLoading, isLoaded, fetchAppointmentDetail } =
    useAppointmentHistory();

  const [searchParams] = useSearchParams();

  const appointmentId = searchParams.get('appointmentId');
  const appointmentProposalId = searchParams.get('appointmentProposalId');

  useEffect(() => {
    if (appointmentId && appointmentProposalId) {
      fetchAppointmentDetail(appointmentId, appointmentProposalId);
    }
  }, [appointmentId, appointmentProposalId, fetchAppointmentDetail]);

  if ((isLoading && !isLoaded) || !currentAppointment) {
    return <Loader isLoading message="Loading Previous Proposal" />;
  }

  return <ProposalTemplatesHistoryDetail template={currentAppointment} />;
};

export default ProposalTemplatesHistoryDetailView;
